export default {
  imageSetting: {
    title: 'フィルター',
  },
  imageEditor: {
    argumentsAreEmpty: 'URL、onCropは必須のパラメータです',
  },
}
